import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState } from 'react';
export var useFlagState = function useFlagState() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      flag = _useState2[0],
      setFlag = _useState2[1];

  var onFlagChange = useCallback(function () {
    setFlag(!flag);
  }, [flag, setFlag]);
  return [flag, onFlagChange];
};